import { AuthActionType } from "redux/actions/actionType";

const initialState = {
  userLoginDetails: {},
  tokenDetails: {},
  getClientLogo: null,
};

export default (state = Object.assign({}, initialState), { type, payload }) => {
  switch (type) {
    case AuthActionType.getUserLoginDetails:
      return {
        ...state,
        userLoginDetails: payload,
      };
    case AuthActionType.getTokenDetails:
      return {
        ...state,
        tokenDetails: payload,
      };
    case AuthActionType.getClientLogo:
      return {
        ...state,
        getClientLogo: payload,
      };

    default:
      return state;
  }
};
